<template>
  <div class="change-device-dialog">
    <div>
      <h1 class="item-title">{{ $t('components_device_scrap.bfsbxx') }}</h1>
      <div class="item-title-info">
        <custom-table :data="list" tableCode="scrapRecord_approval" :filterArr="['action']" :slots="['applyDesc','returnType','action']" height="300px">
          <template slot="applyDesc" slot-scope="scope">
            <el-input v-model="scope.row.applyDesc" width="100%" :disabled="model.type !== 'edit'"></el-input>
          </template>
          <template slot="returnType" slot-scope="scope">
            <custom-select v-model="scope.row.returnType" code="dms_scrap_return_type" width="100%" :placeholder="$t('Common.com_please_select')" :clearable="false" :disabled="!model.approve&&( model.type === 'watch'||model.type ==='edit')"></custom-select>
          </template>
          <template slot="action" slot-scope="scope">
            <el-button type="text" size="mini" @click="deleteBtn(scope.row)">
              {{$t('Common.com_delete')}}
            </el-button>
          </template>
        </custom-table>
      </div>
      <h1 class="item-title">{{ $t('components_device_scrap.shen_qing_xin_xi') }}</h1>
      <div class="item-title-info">
        <el-row>
          <el-col :span="8">
            <span class="label">{{ $t('components_device_scrap.shen_qing_ren') }}:</span>
            <span class="value">{{detail.applyUser }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_device_scrap.shen_qing_shi_jian') }}:</span>
            <span class="value">{{ momentAmPm($momentLocal(detail.applyTime)) }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('components_device_scrap.sqrssgs') }}:</span>
            <span class="value">{{detail.applyOrgName }}</span>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  data() {
    return {
      detail: {},
      list: [],
      info: {},
      selectDevice: [],

    };
  },
  computed: {
    isSubmit: vm => !vm.selectDevice.length
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    getList: function (list) {
      this.orgList = list;
    },

    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        // this.form.orderId = this.model.changeId;

      }
      if (this.model.type === 'edit') {
        // this.form.changeOrderId = this.model.changeId;
        this.getScrapInfo();

      }
      if (this.model.type === 'watch') {
        // this.form.changeOrderId = this.model.changeId;
        this.getScrapInfo();
      }
    },
    // 订单信息
    getScrapInfo: function () {
      this.$getJSON(apis.deviceScrapDetail, {
        batchId: this.model.changeId
      }).then((res) => {
        this.list = res.data;
        this.detail = res.data && res.data[0];
      });
    },
    deleteBtn(data) {
      const tpl = this.$t('components_device_scrap.nqdyscxzdbfsbm');
      this.$showConfirm(tpl)
        .then(() => {
          this.$postJSON(`${apis.DeviceScrapDelete}/${data.scrapApplyId}`, {}, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getScrapInfo();
          });
        })
        .catch(() => {});
    },
    // 确认保存
    onConfirm: function (approve) {
      if (!this.model.approve && this.model.type === 'watch') {
        this.$emit('close');
      }
      // 审批中
      if (this.model.approve && this.model.type === 'watch') {
        const hasEmpty = this.list.find(
          t => t.applyDesc === ''
        );
        if (hasEmpty) {
          const tips = this.$t('components_device_scrap.qtxspjg');
          this.$message.error(tips);
          return;
        }
        this.$emit('close');
      }
      if (this.model.type === 'edit') {
        if (!this.list.length) {
          const tips = this.$t('components_device_scrap.bxsbbnwk');
          this.$message.error(tips);
          return;
        }
        // 判断报废原因不准为空
        const hasEmpty = this.list.find(
          t => t.applyDesc === ''
        );
        if (hasEmpty) {
          const tips = this.$t('components_device_scrap.qtxbfyy');
          this.$message.error(tips);
          return;
        }
        // 草稿编辑
        this.$postJSON(apis.DeviceScrapSetUpdateReasonBatch, {
          detailList: this.list,
          isSubmit: !!approve
        }).then(() => {
          // 清除缓存
          this.clearKeepAlive('scrapRecord');
          this.$emit('onSuccess');
          this.$emit('close');
        });


      }
    }

  }
};
</script>

<style lang="scss"></style>
